import PropTypes from 'prop-types'
import {
  TIPO_PRODUCTO_PRODUCTOS,
  TIPO_PRODUCTO_SCRAP,
  TIPO_PRODUCTO_SERVICIOS,
  TIPO_PRODUCTO_VEHICULOS
} from '../../constants/publicaciones'
import './SeleccionPublicar.css'

const categorias = [
  {
    nombre: TIPO_PRODUCTO_PRODUCTOS,
    icono: 'fa fa-archive',
    descripcion: 'Artículos para vender',
    esScrap: false
  },
  {
    nombre: TIPO_PRODUCTO_SERVICIOS,
    icono: 'fa fa-paint-brush',
    descripcion: 'Servicios que ofrecés',
    esScrap: false
  },
  {
    nombre: TIPO_PRODUCTO_VEHICULOS,
    icono: 'fa fa-car',
    descripcion: 'Autos y otros vehículos',
    esScrap: false
  },
  {
    nombre: TIPO_PRODUCTO_SCRAP,
    icono: 'fa fa-recycle',
    descripcion: 'Materiales para reciclar',
    esScrap: true
  }
]

const CategoriasPrincipales = ({ onClick, selectedTipo }) => {
  return (
    <div
      className="seleccion-grupo seleccion-grupo--cuatro"
      role="radiogroup"
      aria-label="Tipo de producto"
    >
      {categorias.map((categoria) => {
        const estaSeleccionado = selectedTipo === categoria.nombre
        return (
          <button
            key={categoria.nombre}
            type="button"
            name={`btnCategoria${categoria.nombre}`}
            role="radio"
            aria-checked={estaSeleccionado}
            className={`seleccion-card seleccion-card--vertical ${
              estaSeleccionado ? 'seleccion-card--activa' : ''
            }`}
            onClick={() => onClick(categoria)}
          >
            {estaSeleccionado && (
              <i className="fa fa-check-circle seleccion-card-check" aria-hidden="true" />
            )}
            <span className="seleccion-card-icono">
              <i className={categoria.icono} aria-hidden="true" />
            </span>
            <span className="seleccion-card-texto">
              <span className="seleccion-card-titulo">{categoria.nombre}</span>
              <span className="seleccion-card-descripcion">{categoria.descripcion}</span>
            </span>
          </button>
        )
      })}
    </div>
  )
}

CategoriasPrincipales.propTypes = {
  onClick: PropTypes.func.isRequired,
  selectedTipo: PropTypes.string
}

export default CategoriasPrincipales
